// import RulePack from './RulePack';

export default {
  priority: 3,
  path: "packet",
  permissions: ["Salary/SalaryCalculateMenu","888b94f33888b94f3307dc986573ff8823390f3bcf050be9d3b2e0555f5ac0b08dbf8fd2507dc986573ff8823390f3bcf050be9d3b2e0555f5ac0b08dbf8fd25"],
  // component: RulePack,
  component: load(() =>
    import(/* webpackChunkName: "Request-pattern-RulePack" */ "./RulePack")
  ),
  name: app.translate("ضرایب  حقوق و دستمزد"),
  icon: "content-paste",
  drawer: true,
};
